import { createEntitiesReducer, createMenuReducer } from 'app/lib/betting/betting-entities';

import {
  CLEANUP_PREMATCH_CONTENT,
  fetchPrematchCategories,
  getPrematchContent,
} from '../actions';

export const reduceMenuEntities = createMenuReducer({
  REQUEST_ACTION: fetchPrematchCategories.pending.toString(),
  TRIGGER_ACTION: fetchPrematchCategories.fulfilled.toString(),
  FAILURE_ACTION: fetchPrematchCategories.rejected.toString(),
});

export const reduceGridEntities = createEntitiesReducer({
  REQUEST_ACTION: getPrematchContent.pending.toString(),
  TRIGGER_ACTION: getPrematchContent.fulfilled.toString(),
  FAILURE_ACTION: getPrematchContent.rejected.toString(),
  CLEANUP_ACTION: CLEANUP_PREMATCH_CONTENT,
});
